import AppBar from "@mui/material/AppBar";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import MenuIcon from "@mui/icons-material/Menu";
import { alpha, useTheme } from "@mui/material/styles";
import CustomHeaderButton from "../components/CustomHeaderButton";
import { useNavigate } from "react-router-dom";
import CartIcon from "../contexts/Cart/CartIcon";
import LoginDashboardDrawer from "../components/LoginDashboardDrawer";

interface Props {
  onSidebarOpen: () => void;
}

const Header = ({ onSidebarOpen }: Props): JSX.Element => {
  const aboutUSUrl = "/about-us";
  const contactUsUrl = "/contact-us";
  const faqURL = "/faq";
  const theme = useTheme();
  const navigate = useNavigate();

  return (
    <>
      <AppBar
        color="transparent"
        position="sticky"
        sx={{
          border: 0,
          padding: "10px 0",
          top: "auto",
          boxShadow:
            "0 4px 18px 0px rgba(0, 0, 0, 0.12), 0 7px 10px -5px rgba(0, 0, 0, 0.15)",
        }}
      >
        <Toolbar
          sx={{
            minHeight: 70,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <IconButton
            size="large"
            onClick={() => navigate("/")}
            sx={{
              textDecoration: "none",
              cursor: "pointer",
              opacity: 0.8,
              "&:hover": {
                opacity: 1,
              },
              display: "flex",
              alignItems: "center",
            }}
          >
            <img
              src="/images/MAM_Logo_-_2.png"
              alt="logo"
              style={{
                maxWidth: "60px",
                height: "auto",
                filter: theme.palette.mode === "dark" ? "invert(1)" : "none",
              }}
            />
            <Box
              sx={{ display: { md: "inline", xs: "none" }, marginLeft: "10px" }}
            >
              <Typography
                variant="h6"
                sx={{
                  color: theme.palette.text.primary,
                  fontWeight: "bold",
                  textDecoration: "none",
                }}
              >
                Make A Memory Family
              </Typography>
            </Box>
          </IconButton>

          <Box
            sx={{
              flexGrow: 1,
              display: { lg: "flex", md: "none", xs: "none" },
              justifyContent: "flex-end",
              gap: 2,
            }}
          >
            <CustomHeaderButton navigationLink={`/`} text="Home Page" />
            <CustomHeaderButton
              navigationLink={`${aboutUSUrl}`}
              text="About Us"
            />
            <CustomHeaderButton
              navigationLink={`${contactUsUrl}`}
              text="Contact Us"
            />
            <CustomHeaderButton navigationLink={`${faqURL}`} text="FAQs" />
            <LoginDashboardDrawer />
            <CartIcon />
          </Box>

          <Divider
            orientation="vertical"
            sx={{
              height: 32,
              mx: 2,
              display: { lg: "flex", md: "none", xs: "none" },
            }}
          />

          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <Box sx={{ display: { md: "block", lg: "none" } }}>
              <Button
                onClick={() => onSidebarOpen()}
                aria-label="Menu"
                variant="outlined"
                sx={{
                  borderRadius: 0,
                  minWidth: "auto",
                  padding: 1,
                  borderColor: alpha(theme.palette.divider, 0.2),
                }}
              >
                <MenuIcon
                  sx={{
                    color:
                      theme.palette.mode === "dark"
                        ? theme.palette.primary.main
                        : theme.palette.success.dark,
                  }}
                />
              </Button>
            </Box>
          </Box>
        </Toolbar>
      </AppBar>
    </>
  );
};

export default Header;
